import { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/16/solid";
import { obtenerPublicidad } from "../api/api-publicidad";
import { INT_VERTICAL_IMAGE } from "../utils/const/int-const";

export default function VerticalAd() {
    const [imageSets, setImageSets] = useState({
        sm: [],
        md: [],
        lg: [],
    });
    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const response = await obtenerPublicidad();
            if (response.error === false) {
                const big = response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.BIG);
                const medium = response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.MEDIUM);
                const small = response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.SMALL);

                setImageSets(prev => ({
                    ...prev,
                    sm: [...prev.sm, ...small],
                    md: [...prev.md, ...medium],
                    lg: [...prev.lg, ...big],
                }));
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % (imageSets.lg.length || 1));
        }, 5000); // Change every 5 seconds

        return () => clearInterval(interval);
    }, [imageSets]);

    const handlePrev = () => {
        setIndex((prev) =>
            prev === 0 ? (imageSets.lg.length - 1 || 0) : prev - 1
        );
    };

    const handleNext = () => {
        setIndex((prev) => (prev + 1) % (imageSets.lg.length || 1));
    };

    if (loading) return <span>No image available</span>;

    const render = () => {
        try {
            return (
                <div className="relative w-full h-full flex items-center justify-center">
                    <picture className="w-full">
                        {imageSets.lg[index] && (
                            <source
                                media="(min-width: 1920px)"
                                srcSet={imageSets.lg[index].urlImagen}
                            />
                        )}

                        {imageSets.md[index] && (
                            <source
                                media="(min-width: 1440px)"
                                srcSet={imageSets.md[index].urlImagen}
                            />
                        )}

                        {imageSets.sm[index] && (
                            <source
                                media="(min-width: 1280px)"
                                srcSet={imageSets.sm[index].urlImagen}
                            />
                        )}
                        {/* fallback */}
                        {imageSets.sm[index].urlImagen ? (
                            <img
                                src={imageSets.sm[index].urlImagen}
                                alt="Ad"
                                className="object-cover w-full"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    maxWidth: "320px",
                                }}
                            />
                        ) : (
                            <span>No image available</span> // You can replace this with a placeholder image or other UI element
                        )}

                    </picture>

                    {/* Navigation Arrows */}
                    <button
                        onClick={handlePrev}
                        className="absolute left-2 text-gray-600 hover:text-black"
                    >
                        <ChevronLeftIcon size={28} />
                    </button>
                    <button
                        onClick={handleNext}
                        className="absolute right-2 text-gray-600 hover:text-black"
                    >
                        <ChevronRightIcon size={28} />
                    </button>
                </div>
            );
        } catch (error) {
            console.error("Error rendering image:", error);
            return <span>Ads Space</span>;
        }
    }

    return render();
}
